import { Route, Routes } from 'react-router-dom';
import KnowledgeBasePage from './KnowledgeBasePage';
import CollectionPage from './CollectionPage';

export function AdminKnowledgeBase() {
    return (
        <Routes>
            <Route path="/" element={<KnowledgeBasePage />} />
            <Route path="/:collectionId" element={<CollectionPage />} />
        </Routes>
    )
}

export default AdminKnowledgeBase; 